import { render, staticRenderFns } from "./tab-bar-default.mpx?vue&type=template&id=a5d64ea0&isComponent&outputPath=components%2Ftab-bar-default63efd2f4%2Findex"
import script from "./tab-bar-default.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftab-bar-default63efd2f4%2Findex"
export * from "./tab-bar-default.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ftab-bar-default63efd2f4%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports